<script setup name="TvbHomeMpm">
import { reactive, ref, inject } from 'vue'
import { getHomeMpm } from './../../../../api/home'
import { impression, action } from './../../../../utils/gtm'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Controller, Pagination, Autoplay, Navigation, EffectFade } from 'swiper/modules'
import 'swiper/css/effect-fade'
import TvbPlayer from './../../../../components/TvbPlayer/index.vue'
const swiperRef = ref(null)
const swiperPlayerRef = ref(null)
const swiperSmallRef = ref(null)
const size = inject('size')
const width = inject('width')
const mpm = reactive({
  realIndex: 0,
  list: [],
  play: false,
  playState: ''
})

const tvbPlayerRef = ref([])

getHomeMpm().then(({ data }) => {
  mpm.list = data.list
})

const onStateChange = ({ index, state }) => {
  mpm.playState = state
  if (index === mpm.realIndex) {
    for (let i = 0; i < tvbPlayerRef.value.length; i++) {
      const element = tvbPlayerRef.value[i]
      if (i !== index) {
        element?.pause?.()
      }
    }
    if (state === 'play' || state === 'loading') {
      swiperSmallRef?.value?.$el?.swiper?.autoplay?.stop()
      mpm.play = true
    } else if (state === 'ended' || state === 'error') {
      swiperSmallRef?.value?.$el?.swiper?.autoplay?.start()
      mpm.play = false
    }
  }
}

const swiperSlideChange = () => {
  mpm.play = false
  mpm.playState = ''
  if (width.value < 1025) swiperSmallRef.value?.$el?.swiper?.autoplay?.start?.()
  for (let i = 0; i < tvbPlayerRef.value.length; i++) {
    const element = tvbPlayerRef.value[i]
    element?.pause?.()
  }
  mpm.realIndex = swiperSmallRef?.value?.$el?.swiper?.realIndex

  swiperRef?.value?.$el?.swiper?.slideTo(mpm.realIndex)
  const mpmInfo = mpm.list[mpm.realIndex]

  impression({
    page_title: 'home_impression',
    screen_class: mpmInfo?.title,
    screenID: mpmInfo?.id,
    eventCategory: 'home',
    eventLabel: 'home_impression',
    // eventID: mpmInfo?.id,
    eventID: 'impression_mpm_data',
    listName: mpmInfo?.jump_type === 3 ? 'video' : mpmInfo?.button_text ? 'text' : 'image',
    screenLabel: mpmInfo?.button_link
  })
}
const mouseenterMpm = () => {
  swiperSmallRef.value?.$el?.swiper?.autoplay?.stop?.()
}

const mouseleaveMpm = () => {
  if (!mpm.play || mpm.playState === 'pause') swiperSmallRef.value?.$el?.swiper?.autoplay?.start?.()
}
</script>

<template>
  <div class="tvb-home-mpm" :class="[size]" @mouseenter="mouseenterMpm" @mouseleave="mouseleaveMpm">
    <div
      class="tvb-home-mpm_swiper"
      ref="swiperRef"
      :style="{ background: mpm.play ? '#000000' : null }"
    >
      <template v-for="(item, index) in mpm.list" :key="index">
        <div
          :style="{
            position: 'absolute',
            opacity: index === mpm.realIndex && !mpm.play ? 1 : 0,
            top: ' 0px',
            left: '0px',
            width: '100%',
            height: '100%',
            zIndex: index === mpm.realIndex ? 99 : index,
            transition: 'all 1000ms'
          }"
        >
          <tvb-image
            :key="width > 1025 ? 'm' : 'pc'"
            :src="width < 1025 ? item.v_image : item.h_image"
            :alt="item.title"
            backgroundc="#F8F9FA"
            :is-loading-icon="false"
          />
        </div>
      </template>
    </div>
    <div class="tvb-home-mpm_swiper-player" v-if="mpm.list.length && swiperRef">
      <swiper
        class="tvb-home-mpm_swiper-small-player"
        :modules="[Controller, Pagination, Navigation, EffectFade]"
        effect="fade"
        :controller="{ control: swiperSmallRef?.$el?.swiper }"
        loop
        ref="swiperPlayerRef"
        @slide-change-transition-start="swiperSlideChange"
        :pagination="{
          el: '.tvb-home-mpm_swiper-pagination',
          clickable: true
        }"
        :navigation="{
          nextEl: '.tvb-home-mpm_swiper-small-player-button-next',
          prevEl: '.tvb-home-mpm_swiper-small-player-button-prev'
        }"
        :simulate-touch="false"
      >
        <swiper-slide
          v-for="(item, index) in mpm.list"
          :key="`tvb-home-mpm_swiper-small-player-${index}`"
        >
          <tvb-player
            v-if="item.jump_type == 3"
            :src="item.jump_param"
            @state-change="(player) => onStateChange({ ...player, index })"
            ref="tvbPlayerRef"
            @play-click="
              action({
                page_title: 'home_mpm',
                screen_class: item.title,
                screenID: 'S001',
                eventLabel: item.button_text || 'home_mpm',
                eventID: 'impression_mpm_data',
                listName: 'video',
                screenLabel: item.jump_param
              })
            "
          />
          <component
            :is="item.jump_param ? 'tvb-router-link' : 'div'"
            :to="item.jump_param || null"
            class="tvb-player"
            :link-rel="item.link_rel"
            :link-target="item.link_target"
            v-if="item.jump_type !== 3"
            ref="tvbPlayerRef"
            @click="
              action({
                page_title: 'home_mpm',
                screen_class: item.title,
                screenID: 'S001',
                eventLabel: item.button_text || 'home_mpm',
                eventID: 'impression_mpm_data',
                listName: 'image',
                screenLabel: item.jump_param
              })
            "
          />
        </swiper-slide>
        <div class="tvb-home-mpm_swiper-small-player-button-prev">
          <tvb-svg-icon name="icon_arrow_mpm" />
        </div>
        <div class="tvb-home-mpm_swiper-small-player-button-next">
          <tvb-svg-icon name="icon_arrow_mpm" />
        </div>
      </swiper>
      <swiper
        class="tvb-home-mpm_swiper-small"
        :modules="[Controller, Pagination, Autoplay]"
        :controller="{ control: swiperPlayerRef?.$el?.swiper }"
        @slide-change-transition-start="swiperSlideChange"
        :class="{ 'is-play': mpm.play }"
        :pagination="{
          el: '.tvb-home-mpm_swiper-small-pagination',
          clickable: true
        }"
        loop
        ref="swiperSmallRef"
        :autoplay="{
          delay: 5000
        }"
      >
        <swiper-slide
          class="tvb-home-mpm_swiper-small-slide"
          v-for="(item, index) in mpm.list"
          :key="`tvb-home-mpm_swiper-small-slide-${index}`"
        >
          <div style="width: 100%; height: 100%">
            <template v-if="['xl', 'l'].includes(size)">
              <tvb-image
                v-if="item.programme_logo_image.medium"
                :src="item.programme_logo_image"
                :alt="item.title"
                backgroundc="rgba(248, 249, 250, 1)"
                class="tvb-home-mpm_swiper-small-slide-logo"
                :is-loading-icon="false"
              />
              <div v-else class="tvb-home-mpm_swiper-small-slide-title">
                <h3>
                  {{ item.title }}
                </h3>
              </div>
            </template>
            <header class="tvb-home-mpm_swiper-small-header" v-else>
              <tvb-image
                v-if="item.programme_logo_image.medium"
                :src="item.programme_logo_image"
                :alt="item.title"
                :is-loading-icon="false"
                class="tvb-home-mpm_swiper-small-header-logo"
              />
              <h3 v-else class="tvb-home-mpm_swiper-small-header-title">
                {{ item.title }}
              </h3>
              <tvb-button
                v-if="item.button_show === 1"
                :path="item.button_link"
                class="tvb-home-mpm_swiper-small-header-button"
                icon="icon_arrow_mpm"
                :link-ref="item.button_link_rel"
                :link-target="item.button_link_target"
                @click="
                  action({
                    page_title: 'home_mpm',
                    screen_class: item.title,
                    screenID: 'S001',
                    eventLabel: item.button_text || 'home_mpm',
                    eventID: 'impression_mpm_data',
                    listName: 'text',
                    screenLabel: item.button_link
                  })
                "
              >
                {{ item.button_text }}
              </tvb-button>
            </header>
            <p class="tvb-home-mpm_swiper-small-slide-description" :title="item.description">
              {{ item.description }}
            </p>
            <tvb-button
              :path="item.button_link"
              class="tvb-home-mpm_swiper-small-slide-button"
              icon="icon_arrow_mpm"
              :link-ref="item.button_link_rel"
              :link-target="item.button_link_target"
              v-if="['xl', 'l'].includes(size) && item.button_show === 1"
              @click="
                action({
                  page_title: 'home_mpm',
                  screen_class: item.title,
                  screenID: 'S001',
                  eventLabel: item.button_text || 'home_mpm',
                  eventID: 'impression_mpm_data',
                  listName: 'text',
                  screenLabel: item.button_link
                })
              "
            >
              {{ item.button_text }}
            </tvb-button>
          </div>
        </swiper-slide>
        <div class="tvb-home-mpm_swiper-small-pagination"></div>
      </swiper>
    </div>
    <div class="tvb-home-mpm_swiper-pagination"></div>
  </div>
</template>

<style scoped lang="scss">
.tvb-home-mpm {
  height: 477px;
  border-radius: 8px;
  position: relative;
  min-width: 296px;
  background-color: #f8f9fa;
  // * {
  //   -webkit-backface-visibility: hidden;
  //   -webkit-transform-style: preserve-3d;
  // }

  .tvb-home-mpm_swiper {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
    // background: #f0f1f2;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);
    // :deep(.swiper-slide) {
    //   opacity: 0 !important;
    //   &.swiper-slide-active {
    //     opacity: 1 !important;
    //   }
    // }
    @include safari-overflow-hidden();

    @media (max-width: 1024px) and (min-width: 551px) {
      border-radius: 8px !important;
    }

    // :deep(.swiper-slide) {
    //   transition: width 300ms linear;
    // }
  }

  .tvb-home-mpm_swiper-player {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    z-index: 9;
    :deep(.swiper-slide) {
      // transition: width 300ms linear;
      opacity: 0 !important;
      &.swiper-slide-active {
        opacity: 1 !important;
      }
    }
    // :deep(.tvb-player) {
    //   flex: 1;
    // }
  }

  .tvb-home-mpm_swiper-small-player {
    width: calc(100% - 416px);
    height: 100%;
    border-radius: 8px 8px 0px 0px;
    overflow: hidden;
    @include safari-overflow-hidden();

    :deep(.tvb-player) {
      display: block;
      width: 100%;
      height: 100%;
    }

    // :deep(.swiper-slide) {
    //   transition: width 300ms linear;
    // }

    // :deep(.swiper-slide) {
    //   opacity: 0 !important;
    //   &.swiper-slide-active {
    //     opacity: 1 !important;
    //   }
    // }

    .tvb-home-mpm_swiper-small-player-button-next,
    .tvb-home-mpm_swiper-small-player-button-prev {
      transition: all 0.15s linear;
      width: 28px;
      height: 48px;
      background: rgba(0, 0, 0, 0.6);
      position: absolute;
      top: calc((100% - 48px) / 2);
      z-index: 10;
      cursor: pointer;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;

      :deep(.svg-icon) {
        opacity: 0.85;
      }

      &:hover {
        background: rgba(0, 0, 0, 0.8);
        :deep(.svg-icon) {
          opacity: 1;
        }
      }
    }

    .tvb-home-mpm_swiper-small-player-button-next {
      border-radius: 8px 0px 0px 8px;
      right: -28px;
    }

    .tvb-home-mpm_swiper-small-player-button-prev {
      border-radius: 0px 8px 8px 0px;
      left: -28px;
      :deep(.svg-icon) {
        transform: rotate(180deg);
      }
    }

    @media (min-width: 1025px) {
      &:hover {
        .tvb-home-mpm_swiper-small-player-button-next {
          right: 0px;
        }

        .tvb-home-mpm_swiper-small-player-button-prev {
          left: 0px;
        }
      }
    }
  }

  .tvb-home-mpm_swiper-small {
    // position: absolute;
    // right: 0;
    // bottom: 0;
    width: 416px;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 0px 8px 8px 0px;
    margin: 0;
    margin-left: auto;

    &.is-play {
      background: rgba(255, 255, 255, 0.16);
    }
    :deep(.swiper-slide) {
      transition: opacity 300ms 200ms;
      opacity: 0 !important;
      &.swiper-slide-active {
        opacity: 1 !important;
      }
    }

    .tvb-home-mpm_swiper-small-slide-logo {
      width: 300px;
      height: 115px;
      margin: 80px 32px 0;
      background: transparent;
    }

    .tvb-home-mpm_swiper-small-slide-title {
      margin: 119px 32px 0;
      height: 76px;
      overflow: hidden;
      display: flex;
      align-items: flex-end;
      h3 {
        font-size: 32px;
        font-weight: 500;
        color: #eeeeee;
        line-height: 38px;
        letter-spacing: 0.5px;
        @include line-text-ellipsis(2);
      }
    }

    .tvb-home-mpm_swiper-small-slide-description {
      width: calc(100% - 64px);
      height: 104px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.9);
      line-height: 26px;
      margin: 16px auto 0;
      letter-spacing: 0.5px;
      // text-align: justify;
      @include line-text-ellipsis(4);
      overflow: hidden;
    }

    .tvb-home-mpm_swiper-small-slide-button {
      margin: 16px 32px 0;
      display: flex;
      align-items: center;
      :deep(.svg-icon) {
        font-size: 12px;
        position: relative;
      }
    }

    .tvb-home-mpm_swiper-small-pagination {
      position: absolute;
      bottom: 32px;
      left: 32px;
      z-index: 9;
      height: 8px;
      display: flex;

      :deep(.swiper-pagination-bullet) {
        display: inline-block;
        border-radius: 8px;
        width: 8px;
        height: 8px;
        background: rgba(255, 255, 255, 0.3);
        margin-right: 8px;
        cursor: pointer;
        transition: background 0.15s linear;

        &.swiper-pagination-bullet-active,
        &:hover {
          background: rgba(255, 255, 255, 0.8);
        }
      }
    }
  }

  .tvb-home-mpm_swiper-pagination {
    position: absolute;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0px;
    opacity: 0;
    transition: all 500ms;
    :deep(.swiper-pagination-bullet) {
      width: 12px;
      height: 3px;
      background: rgba(163, 178, 188, 0.35);
      border-radius: 2px;
      display: block;
      margin-right: 6px;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      &.swiper-pagination-bullet-active {
        background: #818d95;
      }
    }
    @media (max-width: 1024px) and (min-width: 551px) {
      bottom: -13px;
      opacity: 1;
    }
    @media (max-width: 550px) {
      bottom: -11px;
      opacity: 1;
      :deep(.swiper-pagination-bullet) {
        width: 8px;
        margin-right: 4px;
      }
    }
  }

  &.l,
  &.xl,
  &.m {
    @media (max-width: 1440px) and (min-width: 1025px) {
      height: 400px;

      .tvb-home-mpm_swiper-small-player {
        width: calc(100% - 320px);
      }

      .tvb-home-mpm_swiper-small {
        width: 320px;

        .tvb-home-mpm_swiper-small-slide-logo {
          width: 230px;
          height: 88px;
          margin: 64px 24px 0;
          background: transparent;
        }

        .tvb-home-mpm_swiper-small-slide-title {
          margin: 84px 24px 0;
          height: 68px;
          overflow: hidden;
          h3 {
            font-size: 28px;
            font-weight: 500;
            color: #eeeeee;
            line-height: 34px;
            @include line-text-ellipsis(2);
          }
        }

        .tvb-home-mpm_swiper-small-slide-description {
          width: calc(100% - 48px);
          height: 96px;
          font-size: 15px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.9);
          line-height: 24px;
          margin: 14px auto 0;
          // text-align: justify;
          letter-spacing: 0.3px;
          @include line-text-ellipsis(4);
          overflow: hidden;
        }
        .tvb-home-mpm_swiper-small-slide-button {
          margin: 14px 24px 0;
          display: block;
        }
        .tvb-home-mpm_swiper-small-pagination {
          bottom: 24px;
          left: 24px;
        }
      }
    }
  }

  &.s {
    width: calc(100% - 16px * 2) !important;
  }

  &.m,
  &.s,
  &.xs {
    margin: 12px 12px 0;
    width: calc(100% - 12px * 2);
    border-radius: 6px;

    .tvb-home-mpm_swiper {
      border-radius: 6px;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
    }
    .tvb-home-mpm_swiper-player {
      flex-direction: column;
    }

    .tvb-home-mpm_swiper-small-player {
      width: 100%;
    }
    .tvb-home-mpm_swiper-small {
      backdrop-filter: blur(20px);
      width: 100%;
      // bottom: 0;
      height: auto;
      border-radius: 0px 0px 6px 6px;
      margin-top: auto;

      .tvb-home-mpm_swiper-small-slide {
        padding: 14px;
        .tvb-home-mpm_swiper-small-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .tvb-home-mpm_swiper-small-header-logo {
            width: 98px;
            height: 40px;
            background: transparent;
          }
          .tvb-home-mpm_swiper-small-header-title {
            font-size: 22px;
            font-weight: 500;
            color: #eeeeee;
            line-height: 28px;
            text-shadow: none;
            @include line-text-ellipsis(1);
          }
        }

        .tvb-home-mpm_swiper-small-slide-description {
          margin: 0;
          margin-top: 8px;
          height: auto;
          letter-spacing: 0.3px;
          @include line-text-ellipsis(3);
        }
      }
      :deep(.swiper-pagination-bullet) {
        opacity: 0;
        bottom: -13px;
      }
      .tvb-home-mpm_swiper-small-pagination {
        bottom: -20px;
      }
    }
  }

  &.m,
  &.s {
    @media (max-width: 1024px) and (min-width: 551px) {
      border-radius: 8px !important;
      height: auto;
      max-height: 640px;
      min-height: 500px;
      margin: 0;
      width: 100%;
      aspect-ratio: 1/0.6666666666666666;
      .tvb-home-mpm_swiper-small-player {
        height: calc(100% - 160px);
      }

      .tvb-home-mpm_swiper-small {
        background-color: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(50px);
        height: 160px;
        border-radius: 0px 0px 8px 8px !important;
        &.is-play {
          background-color: rgba(255, 255, 255, 0.08);
        }
        .tvb-home-mpm_swiper-small-slide {
          padding: 18px 22px;
          .tvb-home-mpm_swiper-small-header {
            .tvb-home-mpm_swiper-small-header-title {
              line-height: 64px;
              font-size: 26px;
              font-weight: 500;
              color: #eeeeee;
              text-shadow: none;
              letter-spacing: 0.5px;
            }
            .tvb-home-mpm_swiper-small-header-logo {
              width: 167px;
              height: 64px;
              object-fit: cover;
            }
          }

          .tvb-home-mpm_swiper-small-header-button {
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.9);
            backdrop-filter: none;

            :deep(.span) {
              line-height: 32px;
              --tvb-button-height: 38px;
              --tvb-button-padding: 0 12px 0 18px;
            }
          }

          .tvb-home-mpm_swiper-small-slide-description {
            width: 100%;
            font-size: 16px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.9);
            line-height: 26px;
            letter-spacing: 0.5px;
            @include line-text-ellipsis(2);
          }
        }
      }
    }
  }

  &.s {
    margin: 16px;
    width: calc(100% - 32px);
  }

  &.s,
  &.xs {
    @media (max-width: 550px) {
      border-radius: 6px 6px 0px 0px !important;
      height: auto;
      aspect-ratio: 1 / 0.9285714285714286;

      @supports not (aspect-ratio: 1 / 0.9285714285714286) {
        height: 320px;
      }

      .tvb-home-mpm_swiper-small-player {
        height: calc(100% - 136px);
        border-radius: 6px 6px 0px 0px !important;
      }

      .tvb-home-mpm_swiper-small {
        background-color: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(50px);
        height: 136px;
        border-radius: 0px 0px 6px 6px !important;
        &.is-play {
          background-color: rgba(255, 255, 255, 0.08);
        }
        .tvb-home-mpm_swiper-small-slide {
          padding: 12px 14px 14px;

          .tvb-home-mpm_swiper-small-header {
            .tvb-home-mpm_swiper-small-header-title {
              line-height: 40px;
              font-size: 22px;
              font-family: NotoSansCJKtc, NotoSansCJKtc;
              font-weight: 500;
              // text-shadow: 0px 0px 6px rgba(0, 0, 0, 0.6);
            }
            .tvb-home-mpm_swiper-small-header-logo {
              width: 104px;
              height: 40px;
              object-fit: cover;
            }
            .tvb-home-mpm_swiper-small-header-button {
              font-size: 14px;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.9);
              backdrop-filter: none;

              :deep(.span) {
                line-height: 32px;
                --tvb-button-height: 32px;
                --tvb-button-padding: 0 11px 0 15px;
              }
            }
          }

          .tvb-home-mpm_swiper-small-slide-description {
            width: 100%;
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.9);
            letter-spacing: 0.3px;
            line-height: 20px;
            @include line-text-ellipsis(3);
          }
        }
      }
    }
  }
}
</style>
